/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssignmentTypeEnumDTO } from './assignment-type-enum-dto';
import { VirtualTssDeviceTypeEnumDTO } from './virtual-tss-device-type-enum-dto';
import { VirtualTssStatusEnumDTO } from './virtual-tss-status-enum-dto';
import { VirtualTssMetadataDTO } from './virtual-tss-metadata-dto';
import { CspAccountDTO } from './csp-account-dto';
import { FccDataCenterDTO } from './fcc-data-center-dto';
import { VirtualTssModeEnumDTO } from './virtual-tss-mode-enum-dto';
import { FccInstallationTypeEnumDTO } from './fcc-installation-type-enum-dto';


export interface VirtualTssAllOfDTO { 
    /**
     * Represents the internal id of the Virtual TSS
     */
    id?: string;
    /**
     * Short description of the TSS
     */
    name?: string;
    /**
     * Represents the internal id of the associated business premises
     */
    businessPremisesId?: string;
    /**
     * Represents the internal id of the associated organization
     */
    organizationId?: string;
    /**
     * Represents FCC ID (Client username).
     */
    fccId?: string;
    /**
     * FCC secret
     */
    fccSecret?: string;
    /**
     * Serial number
     */
    tssSerialNumber?: string;
    /**
     * ERS secret
     */
    ersSecret?: string;
    /**
     * Admin PUK
     */
    adminPuk?: string;
    cspAccount?: CspAccountDTO;
    fccInfo?: VirtualTssMetadataDTO;
    fccProperties?: { [key: string]: string; };
    mode?: VirtualTssModeEnumDTO;
    /**
     * Possible values: * CV1 * CV2 
     */
    modeSubtype?: string;
    status?: VirtualTssStatusEnumDTO;
    assignmentType?: AssignmentTypeEnumDTO;
    /**
     * The datetime when Virtual TSS was activated. The datetime field that should be set automatically when FCC service activates the Virtual TSS. 
     */
    activationDate?: string;
    bsiId?: string;
    /**
     * A version string that FCC service should set when an FCC is installed/updated to the version installed
     */
    fccVersion?: string;
    /**
     * The date when the last version updated for the FCC was done
     */
    versionUpdateDate?: string;
    /**
     * The datetime field that will be set when TSS is set to disabled
     */
    deactivationDate?: string;
    /**
     * Hexadecimal representation of HW serial number. It is relevant for token and offline modes.
     */
    hwSerialNumberHex?: string;
    /**
     * Final upload receive data
     */
    finalUploadReceivedDate?: string;
    fccDataCenter?: FccDataCenterDTO;
    deviceType?: VirtualTssDeviceTypeEnumDTO;
    fccInstallationType?: FccInstallationTypeEnumDTO;
    /**
     * Internal User ID of FCC
     */
    userId?: string;
}

export class ClsVirtualTssAllOfDTO { 
    /**
     * Represents the internal id of the Virtual TSS
     */
    id?: string = undefined;
    /**
     * Short description of the TSS
     */
    name?: string = undefined;
    /**
     * Represents the internal id of the associated business premises
     */
    businessPremisesId?: string = undefined;
    /**
     * Represents the internal id of the associated organization
     */
    organizationId?: string = undefined;
    /**
     * Represents FCC ID (Client username).
     */
    fccId?: string = undefined;
    /**
     * FCC secret
     */
    fccSecret?: string = undefined;
    /**
     * Serial number
     */
    tssSerialNumber?: string = undefined;
    /**
     * ERS secret
     */
    ersSecret?: string = undefined;
    /**
     * Admin PUK
     */
    adminPuk?: string = undefined;
    cspAccount?: CspAccountDTO = undefined;
    fccInfo?: VirtualTssMetadataDTO = undefined;
    fccProperties?: { [key: string]: string; } = undefined;
    mode?: VirtualTssModeEnumDTO = undefined;
    /**
     * Possible values: * CV1 * CV2 
     */
    modeSubtype?: string = undefined;
    status?: VirtualTssStatusEnumDTO = undefined;
    assignmentType?: AssignmentTypeEnumDTO = undefined;
    /**
     * The datetime when Virtual TSS was activated. The datetime field that should be set automatically when FCC service activates the Virtual TSS. 
     */
    activationDate?: string = undefined;
    bsiId?: string = undefined;
    /**
     * A version string that FCC service should set when an FCC is installed/updated to the version installed
     */
    fccVersion?: string = undefined;
    /**
     * The date when the last version updated for the FCC was done
     */
    versionUpdateDate?: string = undefined;
    /**
     * The datetime field that will be set when TSS is set to disabled
     */
    deactivationDate?: string = undefined;
    /**
     * Hexadecimal representation of HW serial number. It is relevant for token and offline modes.
     */
    hwSerialNumberHex?: string = undefined;
    /**
     * Final upload receive data
     */
    finalUploadReceivedDate?: string = undefined;
    fccDataCenter?: FccDataCenterDTO = undefined;
    deviceType?: VirtualTssDeviceTypeEnumDTO = undefined;
    fccInstallationType?: FccInstallationTypeEnumDTO = undefined;
    /**
     * Internal User ID of FCC
     */
    userId?: string = undefined;
}



